export const colors = {
  primary: {
    main: '#261f62',
  },
  secondary: {
    main: '#00ffff',
  },
};
